import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeGetCustomersResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeCustomersSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeCustomersSchema>
type Response = DataResponseWithPagination<z.infer<typeof BackofficeGetCustomersResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

export const getBackofficeCustomersQueryKey = (query?: Query) =>
  ["backofficeCustomers", query].filter((e) => e)

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeCustomersQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeCustomersQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/customers", { params: query })
      onSuccess?.(data)
      return data.data
    },
  })
}
